// extracted by mini-css-extract-plugin
export default {"interaction":"_1zEHt","collapseButton":"_2xfla","collapsed":"doC6W"};